module.exports = __webpack_public_path__ + "static/media/sobre_nous_cims.c6fc2f25.jpg";